export default {
	addresses: {
		createNew: 'Neue Adresse erstellen',
	},
}
